import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialogGoToOfferSessionComponent } from 'app/components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { CodeClub } from 'app/shared/models/class/club/club';
import { FormArticle, FormArticleByKey, FormDefinition } from 'app/shared/models/class/forms/form-definition';
import { ArticlePlace, Discipline, FullOffer } from 'app/shared/models/class/offer/offer';
import { Parameter } from 'app/shared/models/class/parameter/parameter';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { PricingOffer, Pricing, Discount } from 'app/shared/models/class/pricing-offer/pricingOffer';
import { TagType, Tag } from 'app/shared/models/class/tags/tag';
import { Universe } from 'app/shared/models/class/universe/universe';
import { ArticleDisciplineService } from 'app/shared/services/articleDiscipline/article-discipline.service';
import { ArticlePlaceService } from 'app/shared/services/articlePlace/article-place.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { DisciplineService } from 'app/shared/services/discipline/discipline.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FormService } from 'app/shared/services/forms/form.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { ParametersService } from 'app/shared/services/parameters/parameters.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UsersService } from 'app/shared/services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';
import { Form } from 'ionic-angular';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const reader = new FileReader();

@Component({
  selector: 'app-admin-offer-edit',
  templateUrl: './admin-offer-edit.component.html',
  styleUrls: ['./admin-offer-edit.component.scss']
})
export class AdminOfferEditComponent extends SubscriptionBaseComponent implements OnInit, OnDestroy {
  mode!: string;
  @Input() offer!: FullOffer;
  @Input() tempoPricing!: boolean;
  @Input() clubCode!: string;

  @Output() offerPreviewUpdate = new EventEmitter<FullOffer>();
  @Output() imageUpdate = new EventEmitter<any>();
  @Output() editFinished = new EventEmitter<boolean>();
  @Output() switchToSession = new EventEmitter<FullOffer>();

  tabSelectedIndex = 0;

  newOffer!: FullOffer;
  tempoPricingExist!: boolean;
  isReturn = false;

  userConnected: any;

  form!: FormGroup;
  pricingForm!: FormGroup;
  filteredOptions!: Observable<string[]>;

  offerPreview = new FullOffer();
  file: any;

  tags: TagType[] = [];
  filteredTags: TagType[] = [];
  tagsSelected: Tag[] = [];
  tagsSelectedString: string[] = [];
  tagsSelectedSecondMainTag: Tag[] = [];
  tagsSelectedThirdMainTag: Tag[] = [];
  mainTags: Tag[] = [];

  clubs: CodeClub[] = [];

  isLoading = false;
  oldImage!: string;

  universes: Universe[] = [];
  parameters: Parameter[] = [];

  filteredParameters: Parameter[] = [];

  color: ThemePalette = 'primary';
  universesSelected: Universe[] = [];

  typeOfInput: string[] = ['texte', 'date', 'heure', 'valeur min/max', 'liste', 'checkbox'];


  offerById!: FullOffer;
  offerKey: any;
  practicesClub: PracticePlace[] = [];
  parametersDefault = this.parametersService.numberOfParametersRequired;
  tooltipExternUrl!: string;
  offerParameterUpdatable = true;
  offerSessionSettable = true;

  maxFiftyLength = 50;

  actorKey!: number;
  disciplineKey!: number;

  disciplineSelected!: Discipline;
  disciplineForm!: Discipline;
  updatePracticePlace!: string;
  clubSelected!: CodeClub;
  disciplines: Discipline[] = [];
  places: ArticlePlace[] = [];
  articleDisciplines: any[] = [];
  forms: FormDefinition[] = [];
  formSelected!: FormDefinition;
  associatedForm!: FormArticleByKey;

  private readonly _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private readonly dataService: DataService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly imgOfferDefault: ImgOfferDefaultService,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService,
    private readonly tooltip: TooltipService,
    private readonly offerService: OfferService,
    private readonly faIconService: FaiconService,
    private readonly uiService: UiService,
    private readonly parametersService: ParametersService,
    private readonly practicePlaceService: PracticePlaceService,
    private readonly clubService: ClubService,
    private readonly parametersSrv: ParametersService,
    private readonly disciplineService: DisciplineService,
    private readonly articleDisciplineService: ArticleDisciplineService,
    private readonly articlePlaceService: ArticlePlaceService,
    private readonly userService: UsersService,
    private readonly formService: FormService
  ) {
    super()
  }


  ngOnInit(): void {
    if (this.offer) {
      this.isLoading = true;
      this.mode = "edit"
    }
    else {
      this.mode = "add";
    }

    this.initComponent();
    this.initSub();
    this.getClubs();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subscription.unsubscribe();
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    if (this.userConnected.role === 'AdminMSR') {
      this.getPracticePlaceByClub();
    }

    if (this.offer) {
      this.offerPreview = this.offer;
      this.articlePlaceService.getByArticle(this.offer.offerKey!).subscribe(places => this.places = places);
    }
    else
      this.offerPreview = new FullOffer();
  }

  private initSub(): void {
    this.initForm();
    this.prepareOfferToForm()

    this.subscription
      .add(
        this.dataService.tagSelectedAddOffer.subscribe({
          next: tagsSelected => {
            this.tagsSelected = tagsSelected;
          }
        })
      )

      .add(
        this.parametersSrv.getParametersActive().subscribe((parametersFromSrv: Parameter[]) => {
          this.parameters = parametersFromSrv;
          this.filteredParameters = [...this.parameters];
        })
      )
  }

  private getClubs(): void {
    this.clubService.getClubs().subscribe({
      next: clubs => {
        this.clubs = clubs?.sort((a, b) => a.code.localeCompare(b.code));
        let club: CodeClub;
        if (this.offer) {
          club = this.clubs.find(c => c.code === this.offer.clubCode)!;
        } else {
          const user = this.userService.getUser();
          club = this.clubs.find(c => c.code === user?.actorCode || c.code === this.userConnected?.club_code)!;
        }
        if (club) {
          this.clubSelected = club;
          this.form.get('clubCode')?.setValue(club);
          if (this.offer) {
            if (this.offer?.universes[0]?.universeKey === 3 || this.offer?.universes[0]?.universeKey === 1) {
              this.disciplineService.getDisciplinesByArticleKey(this.offer.offerKey!).subscribe({
                next: datas => {
                  this.disciplines = datas;
                  const discipline = datas[0];
                  this.form.get('practicePlace')?.setValue(discipline?.label);
                  this.disciplineForm = discipline;
                }
              });
            }
            else {
              this.disciplineService.getDisciplinesByActorKey(this.clubSelected.key).subscribe({
                next: disciplines => {
                  this.articleDisciplineService.get(this.offer.offerKey!).subscribe({
                    next: dataArticles => {
                      this.articleDisciplines = dataArticles;
                      this.disciplines = disciplines;
                      const discipline = disciplines.find(d => d.key === dataArticles[0]?.disciplineKey);
                      this.form.get('practicePlace')?.setValue(discipline);
                      this.disciplineForm = discipline!;
                    }
                  });
                }
              });
            }
          }
          this.setValueForm(club);
          this.getFormsByActorKey(club.key);
        }
      }
    });
  }

  private getFormsByActorKey(actorKey: number): void {
    this.formService.getFormDefinition({actorKey: actorKey}).subscribe({
      next: formDefinitions => {
        this.forms = formDefinitions.filter(fd => fd.enabled);
      },
      error: err => {
        console.error('Error fetching form definitions', err);
      }
    });
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      offerName: [this.offer?.offerName ?? ''],
      clubCode: [null, Validators.required],
      image: [''],
      practicePlace: [null],
      description: [this.offer?.description ?? ''],
      offerClubURL: [this.offer?.offerClubURL ?? '', null],
      customerPromise: [this.offer?.customerPromise ?? ''],
      duration: [this.offer?.duration ?? ''],
      openingPeriod: [this.offer?.openingPeriod ?? ''],
      informations: [this.offer?.informations ?? '', Validators.required],
      services: [this.offer?.services ?? ''],
      environment: [this.offer?.environment ?? ''],
      prerequisites: [this.offer?.prerequisites ?? ''],
      price: [this.offer?.price ?? ''],
      startDate: [this.offer?.startDate ?? null],
      endDate: [this.offer?.endDate ?? null, Validators.required],
      firstMainTag: [''],
      secondMainTag: [''],
      thirdMainTag: [''],
      advantage: [this.offer?.advantage ?? ''],
      photoExperience: [this.offer?.photoExperience ?? '', Validators.maxLength(this.maxFiftyLength)],
      photoExperienceBas: [this.offer?.photoExperienceBas ?? '', Validators.maxLength(this.maxFiftyLength)],
      parameters: this.formBuilder.array([]),
      licence: [null],
      licenceRequired: [this.offer?.licenceRequired ?? false],
      isInternalOffer: [this.offer ? !this.offer.isExternalOffer : false],
      offerSessionSettable: [this.offer?.isExternalOffer ?? false],
      hasSession: [this.offer?.hasSession ?? false],
      universes: [this.offer?.universes ?? []],
      actionName: [this.offer?.actionName],
      formDefinition: [''],
      placeTotal: ['']
    });

    this.pricingForm = this.formBuilder.group({
      fixedPrice: [this.offer?.fixedPrice, [Validators.required, Validators.min(1)]],
      advancePayment: [{ value: this.offer?.advancePayment || 0, disabled: true }, Validators.required],
      isPayableAtClub: this.offer?.isPayableAtClub ? this.offer?.isPayableAtClub : false,
      isPayableOnline: this.offer?.isPayableOnline ? this.offer?.isPayableOnline : false,
      remAge: this.formBuilder.array([]),
      remQTE: this.formBuilder.array([]),
      remTFED: [''],
      remVRES: ['', [Validators.pattern(/[0-9]{5}/), Validators.maxLength(5)]],
      remVRESPercentage: [''],
      remStagiaires: this.formBuilder.array([]),
      cityRemVRES: this.formBuilder.array([])
    });

    if (this.offer?.mainTags) {
      this.f?.firstMainTag.setValue(this.offer?.mainTags[0]?.tagName);
      this.f?.secondMainTag.setValue(this.offer?.mainTags[1]?.tagName);
      this.f?.thirdMainTag.setValue(this.offer?.mainTags[2]?.tagName);
    }

    this.form.get('clubCode')?.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value) {
          this.getPracticePlaceByClub();
        }
      })

    this.form.get('isInternalOffer')?.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value) {
          this.f?.offerClubURL.reset();
          this.f?.offerClubURL.clearValidators();
        } else {
          // this.f?.offerClubURL.setValidators([Validators.required])
        }
        this.f?.offerClubURL.updateValueAndValidity();
      })

  }

  private setValueForm(club: CodeClub): void {
    if (this.userConnected.role === 'AdminMSR') {
      // this.f.clubCode.setValue(this.userConnected.club_code?.toString());
      this.f.clubCode.setValue(club);
      this.f.clubCode.disable();
    }
  }

  getActorKey(value: number): void {
    this.actorKey = value;
    this.getFormsByActorKey(this.actorKey);
  }

  getDisciplineKey(value: number): void {
    if (value === 0) {
      this.disciplineForm = null as any;
    } else {
      this.disciplineKey = value;
    }
  }

  getFormDefinition(value: FormDefinition): void {
    this.formSelected = value;
    this.form.get('actionName')?.setValue(this.formSelected.name);
  }

  back(): void {
    this.offerService.setDataOffer(null);
    this.editFinished.next();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  copyString(): void {
    const offerKey = this.offer.offerKey;
    const link = `${environment.urlSite}home/offer?offerKey=${offerKey}`;
    if (navigator.clipboard) { navigator.clipboard.writeText(link); }
  }

  async onSubmit() {
    if (this.tabSelectedIndex === 0) this.confirmDescription()
    else
      if (this.tabSelectedIndex === 1) this.confirmPricing();
  }


  //TODO a décommenter pour les mainTags
  private addMainTag(): void {
    const mainTagsNotFiltered = [];
    const firstMainTag = this.tagsSelected.find(t => t.tagName === this.f.firstMainTag.value);
    const secondMainTag = this.tagsSelected.find(t => t.tagName === this.f.secondMainTag.value);
    const thirdMainTag = this.tagsSelected.find(t => t.tagName === this.f.thirdMainTag.value);

    mainTagsNotFiltered.push(firstMainTag, secondMainTag, thirdMainTag);
    this.mainTags = mainTagsNotFiltered.filter(t => t !== undefined);
  }

  confirmDescription(): void {
    this.isLoading = true;
    let submit = false;
    if (this.form.invalid) { return; }

    let parameters: any[] = [];

    if (this.form.getRawValue().parameters.length > 0) {
      this.form.getRawValue().parameters.map((oneParam: any) => {
        let param = {
          parameterKey: oneParam.param.parameterKey,
          isFirstPage: oneParam.isFirstPage
        }
        parameters.push(param)
      })
    }

    if (!this.f.hasSession.value) {
      parameters = [];
    }

    this.addMainTag();

    this.newOffer = {
      offerName: this.f.offerName.value,
      clubCode: this.f.clubCode.value?.code,
      image: null as any,
      oldImage: this.oldImage,
      description: this.f.description.value,
      offerClubURL: this.f.offerClubURL.value,
      practicePlace: (this.universesSelected[0]?.universeKey === 3 || this.universesSelected[0]?.universeKey === 1) ? this.f.practicePlace.value : this.f.practicePlace.value?.key,
      practicePlaceKey: this.f.practicePlace.value?.practicePlaceKey,
      customerPromise: this.f.customerPromise.value,
      duration: this.f.duration.value,
      openingPeriod: this.f.openingPeriod.value,
      informations: this.f.informations.value,
      services: this.f.services.value,
      environment: this.f.environment.value,
      price: this.f.price.value,
      prerequisites: this.f.prerequisites.value,
      tags: this.tagsSelected,
      mainTags: this.mainTags,
      advantage: this.f.advantage.value,
      photoExperience: this.f.photoExperience.value,
      photoExperienceBas: this.f.photoExperienceBas.value,
      universes: this.f.universes.value,
      parameters: parameters,
      isExternalOffer: !this.form.get('isInternalOffer')?.value,
      hasSession: this.f.hasSession.value,
      fixedPrice: this.offerPreview.fixedPrice,
      advancePayment: this.offerPreview.advancePayment,
      licenceRequired: this.f.licenceRequired.value,
      startDate: this.form.get('startDate')?.value ?? this.form.get('startDate')?.value?.format('YYYY-MM-DD'),
      endDate: this.form.get('endDate')?.value ?? this.form.get('endDate')?.value?.format('YYYY-MM-DD'),
      actionName: this.f.actionName.value
    };

    if (this.f.licenceRequired.value) {
      this.newOffer.licenceKey = this.f.licence.value.licenceKey;
    }

    switch (this.mode) {
      case 'add':

        if (!this.tagsSelected.length) {
          this.uiService.showSnackbar('Vous devez selectionner des tags');
          this.isLoading = false;
          break;
        }

        submit = true;

        if (submit) {
          this.newOffer.hasSession = this.f.hasSession.value;

          if (!this.f.isInternalOffer.value) {
            this.newOffer.advancePayment = 0;
            this.newOffer.fixedPrice = 0;
            this.newOffer.isExternalOffer = !this.f.isInternalOffer.value;
            this.newOffer.hasSession = false;

            const universeToSet = this.newOffer.universes![0];

            if (universeToSet?.universeKey === 3 || universeToSet?.universeKey === 1) {
              this.offerService.addOffer(this.newOffer).subscribe({
                next: (res) => {
                  const discipline: Discipline = {
                    key: null as any,
                    articleKey: res,
                    label: this.f.practicePlace.value
                  };
                  // Si un formulaire est sélectionné, on crée un FormArticle et on l'associe à l'article
                  if (this.formSelected) {
                    const formArticle: FormArticle = {
                      articleKey: res,
                      formDefinitionKey: this.formSelected.key!,
                      placeTotal: this.f.placeTotal.value
                    }
                    this.formService.postFormArticle(formArticle).subscribe({
                      next: () => {
                        this.disciplineService.postDiscipline(discipline).subscribe({
                          next: dataDiscipline => {
                            const articleDisciple = {
                              articleKey: res,
                              actorKey: this.f.clubCode.value?.key,
                              disciplineKey: dataDiscipline.key
                            };
                            this.articleDisciplineService.post(articleDisciple).subscribe({
                              next: () => {
                                this.articlePlaceService.post(res, this.places).subscribe();
                                if (this.file) {
                                  this.saveImgOffer(res, this.file, true);
                                }
                                this.uiService.showSnackbar(`Article ajouté`);
                                this.editFinished.next(true);
                                this.isLoading = false;
                              }
                            })
                          }
                        });
                      },
                      error: (error: any) => {
                        this.isLoading = false;
                        this.uiService.showSnackbar(error.error);
                      }
                    })
                  } else {
                    this.disciplineService.postDiscipline(discipline).subscribe({
                      next: dataDiscipline => {
                        const articleDisciple = {
                          articleKey: res,
                          actorKey: this.f.clubCode.value?.key,
                          disciplineKey: dataDiscipline.key
                        };
                        this.articleDisciplineService.post(articleDisciple).subscribe({
                          next: () => {
                            this.articlePlaceService.post(res, this.places).subscribe();
                            if (this.file) {
                              this.saveImgOffer(res, this.file, true);
                            }
                            this.uiService.showSnackbar(`Article ajouté`);
                            this.editFinished.next(true);
                            this.isLoading = false;
                          }
                        })
                      }
                    });
                  }
                },
                error: error => {
                  this.isLoading = false;
                  this.uiService.showSnackbar(error.error);
                }
              });

            } else if (this.disciplineKey) {
                this.offerService.addOffer(this.newOffer).subscribe({
                  next: (res) => {
                    this.articlePlaceService.post(res, this.places).subscribe();
                    const articleDisciple = {
                      articleKey: res,
                      actorKey: this.f.clubCode.value?.key,
                      disciplineKey: this.disciplineKey
                    };
                    // Si un formulaire est sélectionné, on crée un FormArticle et on l'associe à l'article
                    if (this.formSelected) {
                      const formArticle: FormArticle = {
                        articleKey: res,
                        formDefinitionKey: this.formSelected.key!,
                        placeTotal: this.f.placeTotal.value
                      };
                      this.formService.postFormArticle(formArticle).subscribe({
                        next: () => {
                          this.articleDisciplineService.post(articleDisciple).subscribe({
                            next: () => {
                              if (this.file) {
                                this.saveImgOffer(res, this.file, true);
                              }
                              this.uiService.showSnackbar(`Article ajouté`);
                              this.editFinished.next(true);
                              this.isLoading = false;
                            }
                          });
                        },
                        error: (error: any) => {
                          this.isLoading = false;
                          this.uiService.showSnackbar(error.error);
                        }
                      });

                    } else {
                      this.articleDisciplineService.post(articleDisciple).subscribe({
                        next: () => {
                          if (this.file) {
                            this.saveImgOffer(res, this.file, true);
                          }
                          this.uiService.showSnackbar(`Article ajouté`);
                          this.editFinished.next(true);
                          this.isLoading = false;
                        }
                      });
                    }
                  },
                  error: error => {
                    this.isLoading = false;
                    this.uiService.showSnackbar(error.error);
                  }
                });
            } else {
              this.offerService.addOffer(this.newOffer).subscribe({
                next: (res) => {
                  this.articlePlaceService.post(res, this.places).subscribe();

                  if (this.file) {
                    this.saveImgOffer(res, this.file, true);
                  }
                  // Si un formulaire est sélectionné, on crée un FormArticle et on l'associe à l'article
                  if (this.formSelected) {
                    const formArticle: FormArticle = {
                      articleKey: res,
                      formDefinitionKey: this.formSelected.key!,
                      placeTotal: this.f.placeTotal.value
                    };
                    this.formService.postFormArticle(formArticle).subscribe({
                      next: () => {
                        this.uiService.showSnackbar(`Article ajouté`);
                        this.editFinished.next(true);
                        this.isLoading = false;
                      },
                      error: (error: any) => {
                        this.isLoading = false;
                        this.uiService.showSnackbar(error.error);
                      }
                    });

                  } else {
                    this.uiService.showSnackbar(`Article ajouté`);
                    this.editFinished.next(true);
                    this.isLoading = false;
                  }
                },
                error: error => {
                  this.isLoading = false;
                  this.uiService.showSnackbar(error.error);
                }
              });
            }
          } else {
            // switch to tab pricing
            this.offer = this.newOffer;
            this.tabSelectedIndex = 1;
            this.isLoading = false;
          }
        }

        break;

      case 'edit':

        this.newOffer.offerKey = this.offerPreview.offerKey;
        this.newOffer.image = this.offerPreview.image;
        this.newOffer.isPayableAtClub = this.offerPreview.isPayableAtClub;
        this.newOffer.isPayableOnline = this.offerPreview.isPayableOnline;

        this.file === undefined ? this.file = null : this.file = this.file;

        if (!this.tagsSelected.length) {
          this.uiService.showSnackbar('Vous devez selectionner des tags');
          this.isLoading = false;
          break;
        }

        submit = true;

        if (submit) {

          this.newOffer.hasSession = this.f.hasSession.value;

          if (!this.f.isInternalOffer.value) {
            this.newOffer.advancePayment = 0;
            this.newOffer.fixedPrice = 0;
            this.newOffer.isExternalOffer = !this.f.isInternalOffer.value;
            this.newOffer.hasSession = false;

            if (this.newOffer.universes[0]?.universeKey === 3 || this.newOffer.universes[0]?.universeKey === 1) {
              if (!this.disciplineForm) {
                if (this.form.get('practicePlace')?.value) {
                  const discipline: Discipline = {
                    key: null as any,
                    articleKey: this.newOffer.offerKey!,
                    label: this.form.get('practicePlace')?.value
                  };
                  this.disciplineService.postDiscipline(discipline).subscribe({
                    next: dataDiscipline => {
                      this.offerService.updateOffer(this.newOffer).subscribe({
                        next: () => {
                          this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();

                          const articleDisciple = {
                            articleKey: this.newOffer.offerKey,
                            actorKey: this.clubSelected.key,
                            disciplineKey: dataDiscipline.key
                          };
                          this.articleDisciplineService.post(articleDisciple).subscribe({
                            next: () => {
                              if (this.formSelected) {
                                const formArticle: FormArticle = {
                                  articleKey: this.newOffer.offerKey!,
                                  formDefinitionKey: this.formSelected.key!,
                                  placeTotal: this.f.placeTotal.value
                                };
                                this.formService.postFormArticle(formArticle).subscribe({
                                  next: () => {
                                    if (this.file) {
                                      this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                                    }
                                    this.uiService.showSnackbar('Article modifié');
                                    this.editFinished.next(true);
                                    this.isLoading = false;
                                  }
                                });
                              } else {
                                if (this.file) {
                                  this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                                }
                                this.uiService.showSnackbar('Article modifié');
                                this.editFinished.next(true);
                                this.isLoading = false;

                              }
                            }
                          });
                        }
                      });
                    }
                  });
                }
                else {
                  this.offerService.updateOffer(this.newOffer).subscribe({
                    next: () => {

                      if (this.places.length > 0) {
                        this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
                      }
                      if (this.file) {
                        this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                      }
                      if (this.formSelected) {
                        const formArticle: FormArticle = {
                          articleKey: this.newOffer.offerKey!,
                          formDefinitionKey: this.formSelected.key!,
                          placeTotal: this.f.placeTotal.value
                        };
                        this.formService.postFormArticle(formArticle).subscribe({
                          next: () => {
                            this.uiService.showSnackbar('Article modifié');
                            this.editFinished.next(true);
                            this.isLoading = false;
                          }
                        });
                      } else {
                        this.uiService.showSnackbar('Article modifié');
                        this.editFinished.next(true);
                        this.isLoading = false;
                      }
                    }
                  });
                }
              }
              else if (this.disciplineForm?.label !== this.form.get('practicePlace')?.value) {
                  const disciplineToEdit: Discipline = {
                    key: this.disciplineForm.key,
                    articleKey: this.newOffer.offerKey!,
                    label: this.form.get('practicePlace')?.value
                  };
                  this.disciplineService.updateDiscipline(disciplineToEdit).subscribe({
                    next: () => {
                      this.offerService.updateOffer(this.newOffer).subscribe({
                        next: () => {
                          if (this.places.length > 0) {
                            this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
                          }
                          if (this.file) {
                            this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                          }
                          if (this.formSelected) {
                            const formArticle: FormArticle = {
                              articleKey: this.newOffer.offerKey!,
                              formDefinitionKey: this.formSelected.key!,
                              placeTotal: this.f.placeTotal.value
                            };
                            this.formService.postFormArticle(formArticle).subscribe({
                              next: () => {
                                this.uiService.showSnackbar('Article modifié');
                                this.editFinished.next(true);
                                this.isLoading = false;
                              }
                            });
                          } else {
                            this.uiService.showSnackbar('Article modifié');
                            this.editFinished.next(true);
                            this.isLoading = false;
                          }
                        }
                      });
                    }
                  });

              } else {
                this.offerService.updateOffer(this.newOffer).subscribe({
                  next: () => {
                    if (this.places.length > 0) {
                      this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
                    }
                    if (this.file) {
                      this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                    }
                    if (this.formSelected) {
                      const formArticle: FormArticle = {
                        articleKey: this.newOffer.offerKey!,
                        formDefinitionKey: this.formSelected.key!,
                        placeTotal: this.f.placeTotal.value
                      };
                      this.formService.postFormArticle(formArticle).subscribe({
                        next: () => {
                          this.uiService.showSnackbar('Article modifié');
                          this.editFinished.next(true);
                          this.isLoading = false;
                        }
                      });
                    } else {
                      this.uiService.showSnackbar('Article modifié');
                      this.editFinished.next(true);
                      this.isLoading = false;
                    }
                  }
                });
              }
            }
            else if (this.disciplineKey) {
              this.offerService.updateOffer(this.newOffer).subscribe({
                next: () => {
                  if (this.places.length > 0) {
                    this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
                  }
                  const articleDiscipline = {
                    articleKey: this.newOffer.offerKey,
                    actorKey: this.f.clubCode.value?.key,
                    disciplineKey: this.disciplineKey
                  };

                  if (this.disciplineForm) {
                    if (this.disciplineForm.key !== this.disciplineKey) {
                      const key = this.articleDisciplines[0].key;
                      this.articleDisciplineService.delete(key).subscribe({
                        next: () => {
                          this.articleDisciplineService.post(articleDiscipline).subscribe({
                            next: () => {
                              if (this.file) {
                                this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                              }
                              if (this.formSelected) {
                                const formArticle: FormArticle = {
                                  articleKey: this.newOffer.offerKey!,
                                  formDefinitionKey: this.formSelected.key!,
                                  placeTotal: this.f.placeTotal.value
                                };
                                this.formService.postFormArticle(formArticle).subscribe({
                                  next: () => {
                                    this.uiService.showSnackbar('Article modifié');
                                    this.editFinished.next(true);
                                    this.isLoading = false;
                                  }
                                });
                              } else {
                                this.uiService.showSnackbar(`Article modifié`);
                                this.editFinished.next(true);
                                this.isLoading = false;
                              }
                            }
                          });
                        }
                      });

                    } else {
                      if (this.file) {
                        this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                      }
                      if (this.formSelected) {
                        const formArticle: FormArticle = {
                          articleKey: this.newOffer.offerKey!,
                          formDefinitionKey: this.formSelected.key!,
                          placeTotal: this.f.placeTotal.value
                        };
                        this.formService.postFormArticle(formArticle).subscribe({
                          next: () => {
                            this.uiService.showSnackbar('Article modifié');
                            this.editFinished.next(true);
                            this.isLoading = false;
                          }
                        });
                      } else {
                        this.uiService.showSnackbar(`Article modifié`);
                        this.editFinished.next(true);
                        this.isLoading = false;
                      }
                    }

                  } else {
                    this.articleDisciplineService.post(articleDiscipline).subscribe({
                      next: () => {
                        if (this.file) {
                          this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                        }
                        if (this.formSelected) {
                          const formArticle: FormArticle = {
                            articleKey: this.newOffer.offerKey!,
                            formDefinitionKey: this.formSelected.key!,
                            placeTotal: this.f.placeTotal.value
                          };
                          this.formService.postFormArticle(formArticle).subscribe({
                            next: () => {
                              this.uiService.showSnackbar('Article modifié');
                              this.editFinished.next(true);
                              this.isLoading = false;
                            }
                          });
                        } else {
                          this.uiService.showSnackbar(`Article modifié`);
                          this.editFinished.next(true);
                          this.isLoading = false;
                        }
                      }
                    });
                  }
                },
                error: error => {
                  this.isLoading = false;
                  this.uiService.showSnackbar(error.error);
                }
              });
            } else {
              this.offerService.updateOffer(this.newOffer).subscribe({
                next: () => {
                  if (this.places.length > 0) {
                    this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
                  }
                  if (this.file) {
                    this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
                  }
                  if (this.formSelected) {
                    const formArticle: FormArticle = {
                      articleKey: this.newOffer.offerKey!,
                      formDefinitionKey: this.formSelected.key!,
                      placeTotal: this.f.placeTotal.value
                    };
                    this.formService.postFormArticle(formArticle).subscribe({
                      next: () => {
                        this.uiService.showSnackbar('Article modifié');
                        this.editFinished.next(true);
                        this.isLoading = false;
                      }
                    });

                  } else {
                    this.uiService.showSnackbar('Article modifié');
                    this.editFinished.next(true);
                    this.isLoading = false;
                  }
                }
              });
            }

          } else {
            this.offer = this.newOffer;
            this.tabSelectedIndex = 1;
            this.isLoading = false;
          }
        }
        break;

      default:
        break;
    }
  }

  confirmPricing() {
    const pricingOffer: PricingOffer = this.formatPricing();

    this.newOffer.isPayableAtClub = this.pricingForm.get('isPayableAtClub')?.value;
    this.newOffer.isPayableOnline = this.pricingForm.get('isPayableOnline')?.value;

    switch (this.mode) {
      case 'add':
        this.offerService.addOffer(this.newOffer).subscribe({
          next: async offerKey => {
            this.articlePlaceService.post(offerKey, this.places).subscribe();
            if (this.file) {
              this.saveImgOffer(offerKey, this.file, true);
            }

            pricingOffer.offerKey = await offerKey;

            this.offerService.addOfferPricing(pricingOffer).subscribe({
              next: () => {

                if (this.form.get('hasSession')?.value) {

                  const dialogRef = this.dialog.open(OpenDialogGoToOfferSessionComponent);

                  dialogRef.afterClosed().subscribe({
                    next: () => {
                      this.newOffer.offerKey = offerKey;
                      this.switchToSession.next(this.newOffer);
                    }
                  });
                } else {
                  // this.uiService.showSnackbar(`Offre ajoutée`);
                  this.uiService.showSnackbar(`Article ajouté`);

                  this.editFinished.next(true);

                  this.isLoading = false;

                }
              }
            });

          },
          error: error => {
            this.uiService.showSnackbar(error.error);
          },
        });
        break;

      case 'edit':
        this.offerService.updateOffer(this.newOffer).subscribe({
          next: () => {
            this.articlePlaceService.post(this.newOffer.offerKey!, this.places).subscribe();
            if (this.file) {
              this.saveImgOffer(this.newOffer.offerKey!, this.file, true);
            }

            pricingOffer.offerKey = this.newOffer.offerKey;

            this.offerService.updateOfferPricing(pricingOffer).subscribe({
              next: () => {

                // this.uiService.showSnackbar('Offre modifiée');
                this.uiService.showSnackbar('Article modifié');

                this.editFinished.next(true);

                this.isLoading = false;
              }
            });

          },
          error: error => { console.error(error); },
        });
        break;

      default:
        break;
    }
  }

  private formatPricing(): PricingOffer {
    const pricing: Pricing[] = [new Pricing(null, this.pricingF.fixedPrice.value)];
    this.pricingF.remAge.value.forEach(el => {
      const limit = `${el.limits[0].min}#${el.limits[0].max}`;
      const rem = new Pricing(limit, el.price);
      pricing.push(rem);
    });

    const discount: Discount[] = [];
    discount.push(
      new Discount('RemQTE', this.pricingF.remQTE?.value[0]?.quantity || 0, this.pricingF.remQTE?.value[0]?.reduction),
      new Discount('RemTFED', null, this.pricingF.remTFED?.value),
      new Discount('RemRES', this.pricingF.cityRemVRES.value.join('#'), this.pricingF.remVRESPercentage?.value),
      new Discount('RemStagiaires', this.pricingF.remStagiaires?.value[0]?.quantity || 0, this.pricingF.remStagiaires?.value[0]?.reduction)
    );
    // discount.push(new Discount('RemTFED', null, this.pricingF.remTFED?.value));
    // discount.push(new Discount('RemRES', this.pricingF.cityRemVRES.value.join('#'), this.pricingF.remVRESPercentage?.value));
    // discount.push(new Discount('RemStagiaires', this.pricingF.remStagiaires?.value[0]?.quantity || 0, this.pricingF.remStagiaires?.value[0]?.reduction));

    const pricingOffer: PricingOffer = {
      advancePayment: this.pricingF.advancePayment.value,
      fixedPrice: this.pricingF.fixedPrice.value,
      isPayableAtClub: this.pricingF.isPayableAtClub.value,
      isPayableOnline: this.pricingF.isPayableOnline.value,
      pricing,
      discount,
    };
    return pricingOffer;
  }

  disabledToggle(): void {
    // this.uiService.showSnackbar('Modification impossible: l\'offre est présente dans un panier ou a déjà été réservée');
    this.uiService.showSnackbar('Modification impossible: l\'article est présent dans un panier ou a déjà été réservée');

  }

  checkForm(): boolean {
    const newOfferCheck = new FullOffer();
    if (this.mode === 'add') {
      newOfferCheck.offerName = this.f.offerName.value || null;
      newOfferCheck.clubCode = this.f.clubCode.value || null;
      newOfferCheck.description = this.f.description.value || null;
      newOfferCheck.practicePlace = this.f.practicePlace.value || null;
      newOfferCheck.price = this.f.price.value || null;
    } else if (this.mode === 'edit') {
      this.offerPreview.practicePlace = this.f.practicePlace.value || null;
    }

    const o = this.mode === 'add' ? newOfferCheck : this.offerPreview;
    const check = o?.offerName && o?.clubCode && o?.description && o?.price && o?.practicePlace && this.tagsSelected?.length;


    if (this.form.invalid) {
      return false;
    }


    return this.f.isInternalOffer.value ? check >= 0 : (check >= 0 && this.f.offerClubURL.value) ? true : false;
  }

  filterMainTags(mainTag: string, { value }) {

    switch (mainTag) {
      case 'first':

        if (this.tagsSelected !== undefined) {
          this.tagsSelectedSecondMainTag = [... this.tagsSelected];
          const indexFirstTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedSecondMainTag.splice(indexFirstTag, 1);
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          if (this.f.secondMainTag.value) {
            if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
            if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
          }

        }
        break;

      case 'second':

        if (this.tagsSelectedSecondMainTag !== undefined) {
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          const indexSecondtTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedThirdMainTag.splice(indexSecondtTag, 1);

          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
        }
        break;

      case 'third':
        if (this.f.secondMainTag.value) {
          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
        }

        break;

      default:
        break;
    }
  }

  updatePreviewOffer(input: string, event?): void {
    this.offerPreview.clubCode = this.userConnected.role === 'AdminMSR' ? this.userConnected.club_code : this.f.clubCode?.value;
    switch (input) {
      case 'offerName':
        this.offerPreview.offerName = this.f.offerName?.value;
        this.dataService.titleAdminOffer.next(this.f.offerName?.value);
        break;
      case 'description':
        this.offerPreview.description = this.f.description?.value;
        break;
      case 'duration':
        this.offerPreview.duration = this.f.duration?.value;
        break;
      case 'practicePlace':
        this.offerPreview.practicePlace = this.f.practicePlace?.value;
        break;
      case 'price':
        this.offerPreview.price = this.f.price?.value;
        break;
      case 'image':
        this.oldImage = this.offerPreview?.image ? JSON.parse(JSON.stringify(this.offerPreview?.image)) : '';
        const file = event?.target.files[0];

        const type = file.type?.split('/')[1];
        const limitSize = 300000;

        (['jpeg', 'png'].includes(type)) ?
          (file.size <= limitSize ?
            (reader.readAsDataURL(file),
              reader.onload = (res) => {
                this.file = file;
                this.offerPreview.image = reader.result.toString() || this.imgOfferDefault.imgDefault;
                this.imageUpdate.next(reader.result.toString())
              }) :
            this.uiService.showSnackbar('la taille de l\'image de doit pas être suppérieure à 300kB')) :
          this.uiService.showSnackbar('Uniquement format jpg ou png');

        break;
      default:
        break;
    }

    // this.formIsValid();
    this.offerPreview.hasSession = this.f.hasSession.value;
    this.offerPreview.isExternalOffer = !this.f.isInternalOffer.value;

    this.offerPreviewUpdate.next(this.offerPreview);

  }

  get f() {
    return this.form?.controls;
  }

  get pricingF() {
    return this.pricingForm?.controls;
  }

  get selectionParameters(): UntypedFormArray {
    return this.form.controls.parameters as UntypedFormArray;
  }

  get selectionParameterRequired(): UntypedFormArray {
    return this.form.controls.parameterRequired as UntypedFormArray;
  }

  getselectionParametersRequiredValues(index: number): UntypedFormArray {
    return this.selectionParameterRequired.controls[index]['controls'].values as UntypedFormArray;
  }

  getselectionParametersValues(index: number): UntypedFormArray {
    return this.selectionParameters.controls[index]['controls'].values as UntypedFormArray;
  }

  getPracticePlaceByClub(): void {
    let clubCode: string;

    switch (this.userConnected?.role) {
      case 'admin':
        clubCode = this.f.clubCode.value;
        break;

      case 'AdminMSR':
        clubCode = this.userConnected.club_code;
        break;

      default:
        break;
    }

    if (!this.clubCode) {
      if (clubCode?.length) {

        this.practicePlaceService.getPracticePlaceByClub(clubCode).subscribe({
          next: async practiceClub => {

            if (this.mode === 'add' && practiceClub?.length === 1) {
              setTimeout(() => this.f.practicePlace.setValue(practiceClub[0]));
            }

            this.practicesClub = practiceClub;
            const practicePlaceToOffer = await practiceClub?.find(pp => pp?.practicePlaceKey === this.offerPreview?.practicePlaceKey);
            this.f.practicePlace.setValue(practicePlaceToOffer);
          }
        });
      }
    }
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private prepareOfferToForm(): void {
    if (this.offer) {
      this.offerService.getOfferById(this.offer.offerKey!).subscribe({
        next: offerById => {
          this.offer = offerById;
          this.offerKey = offerById.offerKey;
          this.offerPreview = this.offer;

          // Je vérifie si l'article est bien associé à un formulaire
          this.formService.getFormDefinitionByArticleKey(this.offerKey).subscribe({
            next: formArticle => {
              this.associatedForm = formArticle;
              if (this.associatedForm) {
                this.form.get('placeTotal')?.setValue(this.associatedForm.placeTotal);
              }
              this.getPracticePlaceByClub();

              this.isLoading = false;

              this.mode !== 'add' ?
                this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags!) :
                this.dataService.tagSelectedAddOffer.next([]);
            },
            error: err => {
              console.error('Error fetching form definitions by article key:', err);
              this.getPracticePlaceByClub();
              this.isLoading = false;

              this.mode !== 'add' ?
                this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags!) :
                this.dataService.tagSelectedAddOffer.next([]);
            }
          });

        }
      });

    } else {
      this.mode !== 'add' ?
        this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags) :
        this.dataService.tagSelectedAddOffer.next([]);
    }
  }

  private saveImgOffer(offerKey: number, file: any, isMainPicture?: boolean): void {
    this.offerService.uploadImg(offerKey, [file], isMainPicture ? true : false).subscribe({
      next: () => { }
    });
  }

  getArray(array: string): UntypedFormArray {
    return this.form.get(array) as UntypedFormArray;
  }

  dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  updateFile(event) {
    this.file = event;
  }

  getTooltipText(values, type): string {
    let valueConvert = [];

    const valuesSplit = values.split('#');
    switch (type) {
      case 'valeur min/max':
        valueConvert = [
          {
            name: 'Min:',
            value: valuesSplit[0]
          },
          {
            name: 'Max:',
            value: valuesSplit[1]
          },
        ];
        break;

      case 'liste':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: ``,
            value: v
          };
          valueConvert.push(value);
        });

        break;

      case 'checkbox':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: `Case ${index + 1}:`,
            value: v
          };
          valueConvert.push(value);
        });
        break;

      default:
        valueConvert = [];
        break;

    }

    let string = '';

    valueConvert.map((param, index) => {
      string += param.name + ' ' + param.value;

      if (index + 1 !== valueConvert.length) {
        string += ', '
      }
    })

    return string;
  }

  onTabChanged(event) {
    if (event.index === 1) this.confirmDescription();
  }

}
